/**
 * Default initializer.
 */
export function axDefaultInitializer() {
    // Nop.
}
